<main *ngIf="!loading" class="col p-2 p-lg-4">
  <h1 class="h5">{{ offer }}</h1>
  <div class="card shadow border-0 p-3">
    <div class="d-block d-lg-flex align-items-center">
      <img [src]="imageService.getImageUrl(offer?.product?.logo, 250, 250, false)" class="img-fluid rounded me-0 me-lg-3 mb-2 mb-lg-0" alt="Offer Image" id="offer-image">

      <div>
        <table class="table table-bordered" id="offer-table">
          <tbody>
          <tr>
            <th>Geos</th>
            <td>{{ offer?.getGeoList() }}</td>
          </tr>
          <tr>
            <th>Payout Type</th>
            <td>{{ ('conversionType.' + offer?.conversionType) | translate }}</td>
          </tr>
          <tr>
            <th>Payout</th>
            <td>{{ offer?.getRegistrationPayout() | currency:2:offer?.currency?.isoCode }}</td>
          </tr>
          <tr>
            <th>Approval Status</th>
            <td>
              <span class="badge" [ngClass]="getOfferStatusClass()">{{ ('partnerOfferStatus.' + getOfferStatus()) | translate }}</span>
            </td>
          </tr>
          <tr>
            <th>Vertical</th>
            <td>
              <ng-container *ngIf="offer?.verticals">
                <ng-container *ngFor="let vertical of offer?.verticals; let last = last">
                  {{ getVerticalName(vertical) | translate }}<ng-container *ngIf="!last"> / </ng-container>
                </ng-container>
              </ng-container>
            </td>
          </tr>
          </tbody>
        </table>

        <button *ngIf="getOfferStatus() === 'apply_to_run' && !connectedUser?.allOffersAccess" (click)="applyOffer()" [disabled]="applying" class="btn btn-primary fw-bold" type="button">
          Apply to Run
        </button>
      </div>
    </div>
  </div>

  <div class="card shadow border-0 mt-4 p-3">
    <h2 class="h6">Offer Description</h2>
    <p [innerHTML]="offer?.descriptionHtml"></p>
  </div>

<!--  <div class="card shadow border-0 mt-4 p-3">-->
<!--    <h2 class="h6">Performance Overview</h2>-->
<!--    <div class="table-responsive">-->
<!--      <table class="table table-hover table-striped text-center">-->
<!--        <thead class="table-light">-->
<!--        <tr>-->
<!--          <th>Date</th>-->
<!--          <th>Clicks</th>-->
<!--          <th>Conversions</th>-->
<!--          <th>EPC</th>-->
<!--          <th>Revenue</th>-->
<!--        </tr>-->
<!--        </thead>-->
<!--        <tbody>-->
<!--        <tr>-->
<!--          <td>Today</td>-->
<!--          <td>150</td>-->
<!--          <td>12</td>-->
<!--          <td>$1.50</td>-->
<!--          <td>$18.00</td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--          <td>Yesterday</td>-->
<!--          <td>200</td>-->
<!--          <td>18</td>-->
<!--          <td>$1.75</td>-->
<!--          <td>$31.50</td>-->
<!--        </tr>-->
<!--        </tbody>-->
<!--      </table>-->
<!--    </div>-->
<!--  </div>-->
</main>
